import $ from 'jquery';

$(document).ready(function () {
  acfCounterBlock();
});

function acfCounterBlock() {
  $('.js-acf-counter').each(function () {});
}
